import classNames from "classnames";
import React, { useCallback } from "react";

import commonStyles from "../../../style.module.css";

const ModalButtonPrimary = ({ children, className, disabled, onClick, dataTestId }) => {
  const onButtonClick = useCallback(
    (e) => {
      try {
        if (onClick) {
          onClick(e);
        }
      } catch (error) {
        console.error(error);
      }
    },
    [onClick],
  );

  return (
    <button
      className={classNames(commonStyles.primaryButton, className)}
      onClick={onButtonClick}
      disabled={disabled}
      data-testid={dataTestId || "ModalButtonPrimary"}
    >
      {children}
    </button>
  );
};

export default ModalButtonPrimary;
